import { createActionGroup, props } from '@ngrx/store';
import {
  WorkOrder, CreateWorkOrderDto, WorkOrderStatus,
  IssueSparePartDto, ClearSparePartCustodyDto, WorkOrderSparePartCustody
} from '../../models/work-order.model';

export const WorkOrderActions = createActionGroup({
  source: 'WorkOrder',
  events: {
    'Load Work Orders': props<{ date?: string; technicianId?: number; from?: string; to?: string; status?: WorkOrderStatus }>(),
    'Load Work Orders Success': props<{ workOrders: WorkOrder[] }>(),
    'Load Work Orders Failure': props<{ error: string }>(),
    'Load Work Order': props<{ id: number }>(),
    'Load Work Order Success': props<{ workOrder: WorkOrder }>(),
    'Create Work Order': props<{ dto: CreateWorkOrderDto }>(),
    'Create Work Order Success': props<{ workOrder: WorkOrder }>(),
    'Attach Cylinder': props<{ workOrderId: number; cylinderId: number }>(),
    'Attach Cylinder Success': props<{ workOrder: WorkOrder }>(),
    'Issue Work Order': props<{ id: number }>(),
    'Issue Work Order Success': props<{ workOrder: WorkOrder }>(),
    'Complete Work Order': props<{ id: number }>(),
    'Complete Work Order Success': props<{ workOrder: WorkOrder }>(),
    'Work Order Failure': props<{ error: string }>(),

    // Part B/Phase 8 — spare-part custody at the work-order level.
    'Load Spare Part Custody': props<{ workOrderId: number }>(),
    'Load Spare Part Custody Success': props<{ workOrderId: number; custody: WorkOrderSparePartCustody[] }>(),
    'Issue Spare Part': props<{ workOrderId: number; dto: IssueSparePartDto }>(),
    'Issue Spare Part Success': props<{ workOrderId: number; custody: WorkOrderSparePartCustody }>(),
    'Clear Spare Part Custody': props<{ workOrderId: number; dto: ClearSparePartCustodyDto }>(),
    'Clear Spare Part Custody Success': props<{ workOrderId: number; custody: WorkOrderSparePartCustody }>(),
  }
});
